<template>
  <form novalidate class="md-layout" :class="content.class_color" @submit.prevent="validateContact">
    <md-field :class="getValidationClass('fullname')" class="form-mb-5">
      <label for="first-last-name">Nombres y apellidos</label>
      <md-input name="first-last-name" id="first-last-name" class="input-black" autocomplete="given-name"
        v-model="form.fullname" :disabled="sending" />
      <span class="md-error" v-if="!$v.form.fullname.required">El nombre y apellido es requerido</span>
      <span class="md-error" v-else-if="!$v.form.fullname.minlength">Nombre y apellido inválido</span>
    </md-field>

    <md-field :class="getValidationClass('business_name')" class="form-mb-5">
      <label for="company">Razón Social</label>
      <md-input name="company" id="company" class="input-black" autocomplete="off" v-model="form.business_name"
        :disabled="sending" />
      <span class="md-error" v-if="!$v.form.business_name.required">La razón social es requerida</span>
      <span class="md-error" v-else-if="!$v.form.business_name.minlength">Razón social invalido</span>
    </md-field>


    <md-field :class="getValidationClass('ruc')" class="form-mb-5">
      <label for="company">RUC</label>
      <md-input name="ruc" id="ruc" class="input-black" autocomplete="off" v-model="form.ruc" :disabled="sending" />
      <span class="md-error" v-if="!$v.form.ruc.required">El RUC es requerido</span>
      <span class="md-error" v-else-if="!$v.form.ruc.minlength">Caracteres mínimos: 11</span>
      <span class="md-error" v-else-if="!$v.form.ruc.maxLength">Caracteres máximos: 11</span>
    </md-field>

    <md-field :class="getValidationClass('category_name')" class="form-mb-5">
      <!-- <label for="area">Rubro</label> -->
      <!-- <md-input type="text" name="area" id="area" autocomplete="off" v-model="form.area"
                :disabled="sending"/> -->

      <b-form-select v-model="form.category_name" :options="options" id="category_name"
        v-on:change="onChangeCategory($event)">


        <!-- These options will appear after the ones from 'options' prop -->
        <b-form-select-option v-for="(item, index) in content" :key="index" :value="item.value" >{{ item.text
        }}</b-form-select-option>

       
      </b-form-select>

      <span class="md-error" v-if="!$v.form.category_name.required">El rubro es requerido</span>
    </md-field>





    <md-field :class="getValidationClass('email')" class="form-mb-5">
      <label for="email">Correo electrónico</label>
      <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
      <span class="md-error" v-if="!$v.form.email.required">El Email es requerido</span>
      <span class="md-error" v-else-if="!$v.form.email.email">Email inválido</span>
    </md-field>

    <b-row class="mx-auto w-100 mb-4">
      <b-col class="m-0 p-0 col-2">
        <md-field :class="getValidationClass('prefix_phone')" class="form-mb-5 select-country">
          <!-- <b-form-select v-model="form.prefix_phone" :options="options2"
              v-on:change="onChangePrefix($event)" > -->

          <!-- This slot appears above the options from 'options' prop -->
          <!-- <template #first>
                    <b-form-select-option :value="+51" disabled>+51</b-form-select-option>
                  </template> -->

          <!-- These options will appear after the ones from 'options' prop -->
          <!-- <b-form-select-option v-for="(item, index) in content" :key="index"
                :value="item.value">{{ item.text }}</b-form-select-option>
              </b-form-select> -->



          <!-- solo esta linea de arriba -->
          <!-- <b-form-select v-if="prove" v-model="form.email" value="hola" :options="options2" v-on:change="onChangePrefix($event)"> -->

          <!-- This slot appears above the options from 'options' prop -->
          <!-- <template #first>
                    <b-form-select-option :value="+51" disabled>+51</b-form-select-option>
                  </template> -->

          <!-- <country-flag country='it' size='normal'/> -->
          <!-- These options will appear after the ones from 'options' prop -->

          <!-- desde aqui se descomenta -->
          <!-- <b-form-select-option v-for="(item, index) in content" :key="index" :value="item.value">{{ item.text }}
            </b-form-select-option> -->
          <!-- </b-form-select> -->

          <b-form-select 
            v-model="selected" 
            :options="options2" 
            v-on:change="onChangePrefix($event)"
            >
          </b-form-select>

        </md-field>


      </b-col>
      <b-col class="m-0 p-0 d-flex align-items-end">
        <md-field class="form-mb-5" :class="getValidationClass('mobilephone')">
          <label for="last-name">Escribe tu número</label>
          <md-input
            name="last-name"
            id="last-name"
            autocomplete="off"
            v-model="form.mobilephone"
            :disabled="sending"
            inputmode="tel"
            maxlength="15"
          />
          <span class="md-error" v-if="!$v.form.mobilephone.required">El número telefónico es requerido</span>
          <span class="md-error" v-else-if="!$v.form.mobilephone.minlength && form.mobilephone !== ''">Mínimo 6
            caracteres</span>
          <span class="md-error" v-else-if="!$v.form.mobilephone.maxLength && form.mobilephone !== ''">Máximo 15
            caracteres</span>
          <span class="md-error" v-else-if="!$v.form.mobilephone.phoneChars && form.mobilephone !== ''">Solo números,
            espacios o símbolos (+ - () )</span>
        </md-field>
      </b-col>
    </b-row>


    <div class="md-field formulario-center-button">
      <div id="formulario-boton">
        <button v-if="content.boton_img" type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global">
            {{ content.text_boton }}
            <!-- <img src="@/assets/images/arrow_left.svg"> -->
          </span>
        </button>
        <button v-else type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global-normal"> {{ content.text_boton }}</span>
        </button>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlert">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send" v-model="showDismissibleAlert" dismissible>
          <span> <strong>{{ lastUser }}</strong><br> Pronto le será agendada una cita!</span>
        </b-alert>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlertError">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send-ganger" variant="danger" v-model="showDismissibleAlertError"
          dismissible>
          <span> Intente mas tarde</span>
        </b-alert>
      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="sending" :can-cancel="true" loader="dots" color="#FFC100" backgroundColor="black" :width=128
        :height=128 :is-full-page="true">
      </loading>
    </div>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import axios from 'axios'
import {
  required,
  email,
  minLength,
  maxLength,
  helpers
} from 'vuelidate/lib/validators'
//  import CountryFlag from 'vue-country-flag'
export default {
  name: 'formulario3',
  mixins: [validationMixin],
  components: { Loading },
  props: { content: Object },
  mounted() {
    // this.sending = true
    // this.success = false
    //   axios.get('/ubigeo/countries')
    //         .then(
    //           result => {

    //             const promise =  result.data.map(
    //                 data => {
    //                   console.log(data, 'hey dataaaaa')
    //                   return {
    //                     value: { code: '+' + data.phone_code, countryId: data.countryId   }, text: '+' + data.phone_code }
    //                 }
    //             )
    //             return promise

    //             // this.prefixCodes = result
    //             // console.log(result.data, 'countriesssss')
    //           }
    //         )

    //  .then(
    //                 result => {
    //                   console.log(JSON.parse(JSON.stringify(result)) )
    //                   this.options2 = JSON.parse(JSON.stringify(result)) 
    //                 }
    //           )
    //         .catch( err => err)

    this.prove = "yes"

  },

  data: () => ({
    form: {
      category_name: null,
      countryId: null,
      email: null,
      ruc: null,
      business_name: null,
      fullname: null,
      mobilephone: null,
      prefix_phone: null
    },
    selected: null,
    selected2: '+51',
    options: [
      { value: null, text: 'Rubro' },
      { value: 'Comidas', text: 'Comidas' },
      { value: 'Market', text: 'Market' },
      { value: 'Salud', text: 'Salud' },
      { value: 'Tiendas', text: 'Tiendas' },
      { value: 'Spa y Belleza', text: 'Spa y Belleza' },
      { value: 'Deporte', text: 'Deporte' },
      { value: 'Hot & Fun', text: 'Hot & Fun' },
      { value: 'Arte y entretenimiento', text: 'Arte y entretenimiento' },
      { value: 'Mascotas', text: 'Mascotas' },
      { value: 'Servicios', text: 'Servicios' }
    ],
    options2: [
      { value: null, text: '+00' },
      {
        value: { countryId: 176, country_code: "pe", country_name: "Peru", phone_code: "51" },
        text: '+51'
      },
      {
        value: { countryId: 11, country_code: "ar", country_name: "Argentina", phone_code: "54" },
        text: '+54'
      },
      {
        value: { countryId: 47, country_code: "co", country_name: "Colombia", phone_code: "57" },
        text: '+57'
      },
      {
        value: { countryId: 45, country_code: "cl", country_name: "Chile", phone_code: "56" },
        text: '+56'
      }
    ],
    contactSaved: false,
    sending: false,
    lastUser: null,
    showDismissibleAlert: false,
    showDismissibleAlertError: false
  }),
  validations: {
    form: {
      countryId: {
        required
      },
      fullname: {
        required,
        minLength: minLength(3)
      },
      business_name: {
        required,
        minLength: minLength(3)
      },
      ruc: {
        required,
        minLength: minLength(11),
        maxLength: maxLength(11)
      },
      category_name: {
        required
      },
      prefix_phone: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(5)
      },
      mobilephone: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(15), // Límite reducido a 15 caracteres
        phoneChars: helpers.regex('phoneChars', /^[0-9+\s()-]+$/)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm() {
      this.$v.$reset()

      this.form.category_name = null
      this.form.countryId = null
      this.form.email = null
      this.form.ruc = null
      this.form.business_name = null
      this.form.fullname = null
      this.form.mobilephone = null
      this.form.prefix_phone = null
    },
    onChangePrefix: function (e) {
      if (e) {
        this.result = JSON.parse(JSON.stringify(e))
        this.form.prefix_phone = '+' + this.result.phone_code
        this.form.countryId = this.result.countryId
      }

    },
    onChangeCategory: function (e) {
      this.form.category_name = e

    },
    saveContact() {
      this.sending = true
      this.form.countryId = 176
      
      // Limpiar el número de teléfono antes de enviar (eliminar espacios y caracteres especiales excepto + - ( ))
      const cleanPhone = this.form.mobilephone ? this.form.mobilephone.replace(/[\s()-]/g, '') : '';
      
      // Limitar a máximo 15 caracteres (estándar internacional E.164)
      const limitedPhone = cleanPhone.substring(0, 15);
      
      const formData = {
        ...this.form,
        mobilephone: limitedPhone
      };
      
      console.log('Enviando teléfono:', limitedPhone, 'Longitud:', limitedPhone.length);
      
      this.$store.dispatch('postBusinessAdvice', formData)
        .then(() => {
          this.showDismissibleAlert = true
          this.contactSaved = true
          this.sending = false
          this.clearForm()
        })
        .catch((error) => {
          console.error('Error al enviar formulario:', error);
          console.error('Detalles:', error.response?.data);
          this.sending = false
          this.showDismissibleAlertError = true
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    validateContact() {
      this.$v.$touch()
      // console.log('validate contact touchhh',
      //   this.form.business_name,
      //   this.form.category_name,
      //   this.form.countryId,
      //   this.form.email,
      //   this.form.fullname,
      //   this.form.mobilephone,
      //   this.form.prefix_phone,
      //   this.form.ruc)
      if (!this.$v.$invalid) {
        this.saveContact()
      }
    },
    getPrefixTlf() {

    },
    srcImagen(img) {
      let src = require('@/assets/images/' + img)
      return src
    },
    doAjax() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    },
    onCancel() {
      // console.log('User cancelled the loader.')
    }
  }
}
</script>
<style scoped></style>